<template>
  <t-trial-default-entry
    sub-heading="Trial"
    heading="トライアルお申し込み"
    :terms-url="kiyakuUrl"
    :terms-size="kiyakuSize"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="show_form" class="t-trial-application-invite-user__instruction">
      <h2>～14日間限定～</h2>
      <br />
      <a-text> 規約に同意した上でトライアルをお申し込みください。 </a-text>
    </div>

    <form class="t-trial-application-invite-user__form" @submit.prevent="handleSubmitForm">
      <a-checkbox id="kiyaku" v-model="agree" label="" :disabled="!kiyakuView">
        <a-button
          id="contractTermsLink"
          variant="text"
          color="primary"
          target="_blank"
          :href="kiyakuUrl"
          title="別ウインドウにてPDF文書が表示されます。"
          @click="kiyakuClick(0)"
        >
          トライアル約款および重要事項説明({{ kiyakuSize }})</a-button
        ><img src="/public/PDF_32.png" class="t-trial-application-invite-user__icon-margin" /> に同意する<br />
        <div class="t-trial-application-invite-user__form__caption">
          ※PDFファイルを開くとチェックを入れることができます。
        </div>
      </a-checkbox>

      <a-checkbox id="kiyaku2" v-model="agree2" label="">
        <a-button id="contractTermsLink2" variant="text" color="primary" target="_blank" :href="kiyakuUrl2">
          NTTコミュニケーションズのプライバシーポリシー
        </a-button>
        に同意する
      </a-checkbox>

      <a-checkbox id="permitRec" v-model="agreeRec" label="">
        本サービス利用時のすべての通話の録音を承諾する
      </a-checkbox>
      <br />
      <a-caption-list
        ><li>上のチェックをすべて入れていただくとお申し込みボタンが押せるようになります。</li></a-caption-list
      >

      <m-button-container class="t-trial-application-invite-user__buttons">
        <a-button
          id="individual"
          variant="block"
          color="primary"
          :disabled="!agree || !agree2 || !agreeRec"
          @click="handleSubmitForm"
        >
          お申し込み
        </a-button>
        <a-button id="back" color="primary" @click="handleCancelClick">戻る</a-button>
      </m-button-container>
      <teleport to="body">
        <o-modal
          id="trialApplicationInviteUser_showModal"
          v-model:visible="showModalDialog"
          class="o-modal-trial-application-invite-user"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <template #title>必要書類の確認</template>
          <div class="t-trial-application-invite-user__box-detail">
            <p>必要書類は準備しましたか？ よろしければお申し込みにお進みください。</p>
            <div class="t-trial-application-invite-user__box t-trial-application-invite-user__box--individual">
              <h3 class="t-trial-application-invite-user__box-title">
                <a-icon icon="user" />
                個人名義でお申し込みの場合
              </h3>
              <ul class="t-trial-application-invite-user__box-list">
                <li class="t-trial-application-invite-user__box-item">運転免許証、またはマイナンバーカード</li>
              </ul>
            </div>
            <div class="t-trial-application-invite-user__box t-trial-application-invite-user__box--coporation">
              <h3 class="t-trial-application-invite-user__box-title">
                <a-icon icon="building" />
                法人名義でお申し込みの場合
              </h3>
              <ul class="t-trial-application-invite-user__box-list">
                <li class="t-trial-application-invite-user__box-item">登記事項証明書 (登記簿謄本）</li>
                <li class="t-trial-application-invite-user__box-item">
                  お申し込み者様の運転免許証、またはマイナンバーカード
                </li>
                <li class="t-trial-application-invite-user__box-item">
                  委任状 (お申し込み者様が会社役員の場合は不要）
                </li>
              </ul>
            </div>
          </div>

          <!-- eslint-enable -->
          <template #footer>
            <a-button
              id="back"
              variant="outlined"
              color="primary"
              label="戻る"
              size="small"
              @click="showModalDialog = false"
            />
            <a-button
              id="next"
              variant="block"
              color="primary"
              submit="submit"
              label="お申し込みに進む"
              size="small"
              @click="handleSubmitForm"
            />
          </template>
        </o-modal>
      </teleport>
    </form>

    <teleport to="body">
      <o-modal
        id="trialApplicationInviteUser_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-trial-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TTrialDefaultEntry from '@/components/templates/trial-default-entry';
import AIcon from '@/components/atoms/icon';
import AButton from '@/components/atoms/button';
import ACheckbox from '@/components/atoms/checkbox';
import AText from '@/components/atoms/text';
import ACaptionList from '@/components/atoms/caption-list';
import MButtonContainer from '@/components/molecules/button-container';
import Simplebar from 'simplebar';
import OModal from '@/components/organisms/modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { LP_URL } from '@/libs/constants';

import { utils } from '@/common/utils.js';

export default {
  name: 't-trial-application-invite-user',
  components: {
    TTrialDefaultEntry,
    AIcon,
    AButton,
    ACheckbox,
    AText,
    ACaptionList,
    MButtonContainer,
    OModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    priceList: {
      type: Array,
      default: new Array(0),
    },
    individualList: {
      type: Array,
      default: new Array(0),
    },
    coporationList: {
      type: Array,
      default: new Array(0),
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleProceedClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      agree: false,
      agree2: false,
      agreeRec: false,
      showModalDialog: false,
      kiyakuUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/kiyaku_trial.pdf',
      kiyakuSize: '1707KB',
      kiyakuUrl2:
        'https://www.ntt.com/about-us/hp/privacy.html?elqTrackId=0c8d50a4b4b2443c9cab8fd4438cc151&elqaid=778&elqat=2&_ga=2.11629171.655034696.1641532286-717115474.1641532286',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      businessType: '',
      kiyakuView: false,
      kiyakuView2: false,
      show_form: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-trial-application-invite-user');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    document.title = 'トライアルお申し込み | COTOHA Call Center';

    this.show_form = true;
    utils.setMetaDescription(this.$route);
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      this.postRequest('/signup/createtmpdata')
        .then(async e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('トライアルお申し込み'));
            } else {
              await this.setCookie('tmpUUID', e.tmpUUID, 'tmpYMD', e.tmpYMD);

              const tmpData = {
                businessType: this.businessType,
              };

              this.postRequest('/signup/updateBusinessType', {
                tmpCompanyID: e.tmpUUID,
                tmpYMD: e.tmpYMD,
                validate: false,
                data: tmpData,
              })
                .then(e => {
                  if (e.session) {
                    if (e.status === 'failed') {
                      this.showErrorModal(messageContent.requireTry('トライアルお申し込み'));
                    } else {
                      this.$router.push({ path: '/trial-signup/form' });
                    }
                  } else {
                    window.location.href = '/login';
                  }
                })
                .catch(err => {
                  console.log(err);
                  this.showErrorModal(messageContent.requireTry('トライアルお申し込み'));
                });
            }
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('トライアルお申し込み'));
        });
    },
    setCookie: async function (key, value, key2, value2) {
      await this.postRequest('/signup/setCookie', { key: key, value: value, key2: key2, value2: value2 })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('トライアルお申し込み'));
            }
          } else {
            window.location.href = '/';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('トライアルお申し込み'));
        });
    },
    handleCancelClick() {
      window.location.href = LP_URL;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showModal(type) {
      this.businessType = type;
      this.showModalDialog = true;
    },
    kiyakuClick(kiyaku_number) {
      if (kiyaku_number === 0) {
        this.kiyakuView = true;
      }
    },
  },
};
</script>
